module.exports = __webpack_public_path__ + "media/images/brands/kirkby-tyres-assist/logo-65be1f227f4898779a5c6ab437dcbb45.jpg";